import {otsBaseApi} from "../../ots-api";
import {
  RefServiceCondition,
  RefServiceMode,
  RefServiceStatus,
  RefServiceStatusFacet
} from "../../../model/service/service-ref";

const ALL_TAG_TYPES = [
  "RefServiceConditions",
  "RefServiceModes",
  "RefServiceStatuses",
  "RefServiceStatusFacets"
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const serviceTypeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRefServiceConditions: builder.query<RefServiceCondition[], void>({
      query: () => ({
        url: `/service/ref/service-conditions/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        return [{type: "RefServiceConditions", id: "LIST"}]
      }
    }),
    getAllRefServiceModes: builder.query<RefServiceMode[], void>({
      query: () => ({
        url: `/service/ref/service-modes/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        return [{type: "RefServiceModes", id: "LIST"}]
      }
    }),
    getAllRefServiceStatuses: builder.query<RefServiceStatus[], void>({
      query: () => ({
        url: `/service/ref/service-statuses/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        return [{type: "RefServiceStatuses", id: "LIST"}]
      }
    }),
    getAllRefServiceStatusFacets: builder.query<RefServiceStatusFacet[], void>({
      query: () => ({
        url: `/service/ref/service-status-facets/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        return [{type: "RefServiceStatusFacets", id: "LIST"}]
      }
    }),
  })
});

export const {
  useGetAllRefServiceConditionsQuery,
  useGetAllRefServiceModesQuery,
  useGetAllRefServiceStatusesQuery,
  useGetAllRefServiceStatusFacetsQuery,
} = serviceTypeApi;
